import PWAPrompt from './PWAPrompt';

export default PWAPrompt;
